(function(angular){
	'use strict';

	angular
		.module('viewReitElementModule')
		.directive('timelineItem', [
			'$window',
			'BREAKPOINTS',
			timelineItemFunction
		]);

	function timelineItemFunction(
		$window,
		BREAKPOINTS
	) {
		return {
			restrict: 'A',
			link: function($scope, $element, $attrs) {

				var marginTop;
				var element = $element[0];
				var prevElement = element.previousElementSibling;

				if($window.innerWidth >= BREAKPOINTS.MD_START && prevElement !== null) {
					$scope.$watch(function() {
						return element.clientHeight;
					}, function(newHeight) {
						marginTop = element.clientHeight < prevElement.clientHeight ? element.clientHeight : prevElement.clientHeight;
						marginTop = (-1 * marginTop / 2) + 68;
						element.style.marginTop = marginTop + 'px';
					});
				}
			}
		};
	}
})(window.angular);